import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold leading-tight text-2xl mt-0" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex justify-end items-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_7 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_8 = { class: "w-full xl:w-1/2" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "w-full xl:w-1/2 flex xl:justify-end justify-start" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "flex gap-3 xl:flex-row flex-col items-start mb-3" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "input-wrapper" }
const _hoisted_15 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.form.name.value ? _ctx.form.name.value : 'Title here'), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.update()), ["prevent"])),
              class: "cursor-pointer rounded-md bg-white text-theme-green py-2 px-3 hover:bg-theme-darkgreen hover:text-white mr-3"
            }, " SAVE "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
              class: "cursor-pointer rounded-md text-white py-2 pl-1 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name.value) = $event)),
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['name']))),
              placeholder: "Name",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.name.value]
            ]),
            (_ctx.form.name.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.name.error_message)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass('input-wrapper ' + (_ctx.form.reasonCode.error_type))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs mb-1" }, "Reason Code", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.reasonCode.value) = $event)),
              onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFields(['reasonCode']))),
              placeholder: "Reason Code",
              class: "placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white",
              type: "text"
            }, null, 544), [
              [_vModelText, _ctx.form.reasonCode.value]
            ]),
            (_ctx.form.reasonCode.error_message)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-error label-text mt-1",
                  textContent: _toDisplayString(_ctx.form.reasonCode.error_message)
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs mb-1" }, "Description", -1)),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.description) = $event)),
                class: "border-none block rounded bg-gray-black w-full text-sm"
              }, null, 512), [
                [_vModelText, _ctx.form.description]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}